import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function HomeCTASection() {
  const { t } = useTranslation();

  return (
    <section className="relative py-28 overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0 w-full h-full">
        <img
          src="https://public.readdy.ai/ai/img_res/282dda65258042de311a3a0af302421f.jpg"
          alt="Transform your home"
          className="w-full h-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-r from-slate-900/85 via-slate-900/70 to-slate-900/50"></div>

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-6">
        <div className="max-w-2xl">
          <span className="text-sky-400 text-sm font-bold uppercase tracking-widest">{t('cta_tag')}</span>
          <h2 className="text-4xl md:text-5xl font-black text-white mt-3 mb-5 leading-tight">
            {t('cta_title1')}<br />{t('cta_title2')}
          </h2>
          <p className="text-white/80 text-lg leading-relaxed mb-10">
            {t('cta_desc')}
          </p>

          <div className="flex flex-col sm:flex-row gap-4">
            <Link
              to="/water-purification"
              className="bg-sky-500 hover:bg-sky-400 text-white font-bold px-8 py-4 rounded-lg flex items-center gap-3 whitespace-nowrap transition-all cursor-pointer text-base justify-center"
            >
              <div className="w-5 h-5 flex items-center justify-center">
                <i className="ri-drop-line text-lg"></i>
              </div>
              {t('cta_water')}
            </Link>
            <Link
              to="/windows-services"
              className="bg-white/15 hover:bg-white/25 border-2 border-white/50 text-white font-bold px-8 py-4 rounded-lg flex items-center gap-3 whitespace-nowrap transition-all cursor-pointer text-base justify-center"
            >
              <div className="w-5 h-5 flex items-center justify-center">
                <i className="ri-window-line text-lg"></i>
              </div>
              {t('cta_windows')}
            </Link>
          </div>

          <p className="text-white/50 text-sm mt-6 flex items-center gap-2">
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-check-line text-sky-400 text-base"></i>
            </div>
            {t('cta_note')}
          </p>
        </div>
      </div>
    </section>
  );
}
